export const percentToMicro = (percent: number | string | null): string | null => {
  if (!percent) {
    return null;
  }

  return (+percent / 100).toString();
};

export const percentToMicroWithPrecision = (
  percent: number | string | null | undefined,
  precision = 3
): string | null => {
  if (percent === null || percent === undefined || percent === '') {
    return null;
  }

  return (+percent / 100).toFixed(precision);
};

export const percentToMicroStr = (percent?: number | string | null) => {
  if (!percent) {
    return null;
  }
  percent = `${percent}`;
  const [str1, str2] = percent.split('.');
  const res = str1.padStart(3, '0');
  const dec = res.slice(-2);
  const int = res.slice(0, -2);
  const num = +`${int}.${dec}${str2 ?? ''}`;
  return `${num}`;
};
